
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chat_spaces/new/dm",
      function () {
        return require("private-next-pages/chat_spaces/new/dm.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chat_spaces/new/dm"])
      });
    }
  